<template>
    <div id="welcome-screen" class="welcome-screen position-relative">
        <div class="welcome-screen-overlay"></div>
       <!-- <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
            <source src="@/assets/video.mp4" type="video/mp4">
        </video> -->
       <!-- <img class="welcome-screen-logo" src="@/assets/images/logo.png" alt="kickoff-logo" width="250"> -->
        <br>
        <div class="container-fluid container-3xl mt-5 pad-pc">
            <div class="row position-relative justify-content-center" style="padding: 25px;">

                <div class="col-12 col-lg-4 py-5 position-relative text-center back-st">
                    <img src="@/assets/images/logo.png" alt="kickoff-logo" width="150" style="padding-bottom: 25px">
                    <div class="welcome-screen-text-s">
                        <h4>Prague</h4>
                        <p>17 - 18 January 2026<br><span>Kongresové centrum Praha</span></p>
                    </div>
                    <router-link to="/prague">
                        <button type="button" class="btn btn-primary btn-gre">Enter</button>
                    </router-link>
                    
                </div>
                
                <div class="col-12 col-lg-4 py-5 position-relative text-center back-st">
                    <img src="@/assets/images/logo.png" alt="kickoff-logo" width="150" style="padding-bottom: 25px">
                    <div class="welcome-screen-text-s">
                        <h4>Москва</h4>
                        <p>31 января 2026 года<br><span>Международный центр бокса,<br> Новолужнецкий проезд д.13</span></p>
                    </div>
                    <router-link to="/moscow">
                        <button type="button" class="btn btn-primary btn-gre">Войти</button>
                    </router-link>
                </div>

                <div class="col-12 col-lg-4 py-5 position-relative text-center back-st">
                    <img src="@/assets/images/logo.png" alt="kickoff-logo" width="150" style="padding-bottom: 25px">
                    <div class="welcome-screen-text-s">
                        <h4>Бишкек</h4>
                        <p>7 февраля 2026 года<br><span>Anel Grand Hall,<br> Бишкек</span></p>
                    </div>
                    <router-link to="/biskek">
                        <button type="button" class="btn btn-primary btn-gre">Войти</button>
                    </router-link>
                </div>

                <!--
                <img src="@/assets/KICK_OFF_2025_vez_moskva.webp" alt="background image Moscow" class="bg-img moscow d-none d-lg-block">
                <img src="@/assets/KICK_OFF_2025_vez_praha.webp" alt="background image Prague" class="bg-img prague d-none d-lg-block">
            -->
            </div>
        </div>

<!--
        <img src="@/assets/KICK_OFF_2025_vez_moskva.webp" alt="background image Moscow" class="bg-img moscow d-none d-lg-block">
        <img src="@/assets/KICK_OFF_2025_vez_praha.webp" alt="background image Prague" class="bg-img prague d-none d-lg-block">
-->
    </div>

</template>

<script setup>
    const { onMounted, ref }=require("@vue/runtime-core")

</script>

<style scoped>

    .navbar {
        display: none !important;
    }

    .back-st {
        z-index: 10;
        background: rgba(0, 0, 0, 0.5);
        margin: 5px;
    }

    .btn-gre {
        border-radius: 0;
        border: 2px solid #f48257;
        color: #000000;
        background-color: #f48257;
        font-weight: bold;
        min-width: 145px;
    }

    .btn-gre:hover, .btn-sec:focus {
    border-color: #f48257;
    color: #f48257;
    background-color: #000000;
}

    .welcome-screen {

        margin-top: 0;
    }

    .welcome-screen-logo {
        position: absolute;
        top: 47%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 50%;
    }

    .welcome-screen-text-s h4 {
        color: white;
    }

    .welcome-screen-text-s p {
        color: white;
    }

    .welcome-screen-text-s span {
        color: #f48257;
    }

    .welcome-screen-text-s {
        min-height: 122px;
        text-align: center;
        position: relative;
    }

    .welcome-screen-overlay {
        z-index: -2;
        position: fixed;
        overflow-x: hidden;
        background: linear-gradient(180deg, #493360 20.59%, #f47f47 180.71%)
    }

    .bg-img {
    position: fixed;
    bottom: 0;
    opacity: 50%;
    z-index: -1;
}

.bg-img.prague {
    z-index: -1;
    left: -2.5%;
    width: 25%;
}

.bg-img.moscow {
    z-index: -1;
    right: -14%;
    width: 40%;
}

@media (min-width: 1700px) {
    .bg-img.prague {
        z-index: -1;
        left: -2%;
        height: 118%;
        bottom: -3%;
    }

    .bg-img.moscow {
        z-index: -1;
        right: -8%;
    }
}

@media (max-width: 1000px) {
    .pad-pc {
        padding-top: 0px;
        padding-bottom: 150px;
    }

    .welcome-screen {
        height: 100% !important;
        margin-top: 0;
    }
}

@media (min-width: 1000px) {
    .pad-pc {
        padding-top: 50px;
    }
}

.welcome-screen {
    margin-top: 0;
}


</style>